/**
 * Valid inputs must be convertible to a postive integer or null value
 *
 * null input means number of entrances are unlimited
 */
export const validateEntranceLimit = (input?: number | null) =>
  input != null && (!Number.isInteger(input) || input <= 0 || input > 100)
    ? 'The specified limit must be a positive integer and no greater than 100 or a blank input for unlimited entrances'
    : null;

export const validateSimultaneousLimit = (
  simultaneousLimit?: number | null,
  lifetimeLimit?: number | null,
  text: Record<string, string> = { simultaneousGreaterThanLifetimeLimitError: '' },
) =>
  simultaneousLimit && lifetimeLimit && simultaneousLimit > lifetimeLimit
    ? text.simultaneousGreaterThanLifetimeLimitError
    : validateEntranceLimit(simultaneousLimit);
